/** @format */

import {useEffect, useState, useCallback} from 'react';
import {useFetch} from 'frontier-utilities';
import update from 'immutability-helper';
import SuperAgent from 'superagent';

export const useOrder = orderId => {
    const [state, setState] = useState({
        order: {},
        cart: {},
        shipments: [],
        designs_orders: [],
        proofs: []
    });

    useFetch(
        `/account/orders/view/${orderId}`,
        ({order: {designs_orders, proofs, cart, ...order}, shipments}) => {
            setState({designs_orders, proofs, order, shipments, cart});
        }
    );

    const handleUpdateProof = useCallback((orderId, proofId, proof) => {
        setState(prevState => {
            const proofIndex = prevState.proofs.findIndex(proof => proof.id == proofId);

            const updateTarget = {order: {}, proofs: {}};

            updateTarget.order = {
                external_status_label: {$set: proof.order.external_status_label},
                status_icon: {$set: proof.order.status_icon}
            };

            updateTarget.proofs = {$splice: [[proofIndex, 1, proof]]};

            return update(prevState, updateTarget);
        });
    }, []);

    return {...state, handleUpdateProof};
};
